import { render, staticRenderFns } from "./BrandModelCreateOrUpdate.vue?vue&type=template&id=9fa2ac82&"
import script from "./BrandModelCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./BrandModelCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports